import { NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { environment } from 'src/environments/environment';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';
import { PageContainerSimpleComponent } from './components/pages/page-container-simple/page-container-simple.component';
import { PageContainerComponent } from './components/pages/page-container/page-container.component';
import { PropertySoldComponent } from './components/pages/properties-sold/property-sold/property-sold.component';

export const routes: Routes = [
  // Kaupsagan - Stök fasteign
  {
    path: 'portal/kaupsagan/:id', loadChildren: () => import('./components/pages/properties-sold/properties-sold.module').then(m => m.PropertiesSoldModule), component: PropertySoldComponent,
  },

  // MBL - Kaupsagan - Stök fasteign
  {
    path: 'mbl/kaupsagan/:id', loadChildren: () => import('./components/pages/properties-sold/properties-sold.module').then(m => m.PropertiesSoldModule), component: PropertySoldComponent,
  },

  // MBL - Kaupsagan - DEMO inject
  {
    path: 'mbl-kaupsagan',
    redirectTo: '/assets/mbl-kaupsagan/index.html',
    pathMatch: 'full'
  },
  {
    path: 'mbl-kaupsagan-yfirlit',
    redirectTo: '/assets/mbl-kaupsagan-yfirlit/index.html',
    pathMatch: 'full'
  },

  // E-fasteignir og Kaupsagan - Main paths
  {
    path: '',
    component: PageContainerComponent,
    children: [
      { path: '', loadChildren: () => import('./components/pages/home/home.module').then(m => m.HomeModule) },
      { path: 'skrauremaillista/:token', loadChildren: () => import('./components/pages/home/home.module').then(m => m.HomeModule) },
      { path: 'skraurfrettaposti/:token', loadChildren: () => import('./components/pages/home/home.module').then(m => m.HomeModule) },
      { path: 'personuverndarstefna', loadChildren: () => import('./components/pages/personuverndarstefna/personuverndarstefna.module').then(m => m.PersonuverndarstefnaModule) },
      { path: 'um-okkur', loadChildren: () => import('./components/pages/home/home.module').then(m => m.HomeModule) },
      { path: 'notendaskilmalar', loadChildren: () => import('./components/pages/userterms/userterms.module').then(m => m.UserTermsModule) },
      { path: 'verdmat-utskyring', loadChildren: () => import('./components/pages/verdmat-utskyring/verdmat-utskyring.module').then(m => m.VerdmatUtskyringModule) },
      { path: 'hafa-samband', loadChildren: () => import('./components/pages/contact/contact.module').then(m => m.ContactModule) },
      { path: 'fasteignir/kaupsagan', loadChildren: () => import('./components/pages/properties-sold/properties-sold.module').then(m => m.PropertiesSoldModule) },
      { path: 'kaupsagan', loadChildren: () => import('./components/pages/properties-sold/properties-sold.module').then(m => m.PropertiesSoldModule) },
      { path: 'kaupsagan-ljosmyndun', loadChildren: () => import('./components/pages/properties-sold/properties-sold.module').then(m => m.PropertiesSoldModule) },
      { path: 'fasteignir/til-solu', loadChildren: () => import('./components/pages/properties-for-sale/properties-for-sale.module').then(m => m.PropertiesForSaleModule) },
      { path: 'til-solu', loadChildren: () => import('./components/pages/properties-for-sale/properties-for-sale.module').then(m => m.PropertiesForSaleModule) },
      { path: ':fasteignasalaNafn/solusida', loadChildren: () => import('./components/pages/properties-for-sale/properties-for-sale.module').then(m => m.PropertiesForSaleModule) },
      { path: 'eftirlitsnefnd-fasteignasala', loadChildren: () => import('./components/pages/eftirlitsnefnd-fasteignasala/eftirlitsnefnd-fasteignasala.module').then(m => m.EftirlitsnefndFasteignasalaModule) },
      { path: 'verdskra', loadChildren: () => import('./components/pages/pricing/pricing.module').then(m => m.PricingModule) },

      // Passa að matcha einnig url frá gamla vefsvæði:
      { path: 'forsida/fasteignir-til-solu/fasteign', loadChildren: () => import('./components/pages/properties-for-sale/properties-for-sale.module').then(m => m.PropertiesForSaleModule) },
      { path: 'forsida/um-okkur/notendaskilmalar', loadChildren: () => import('./components/pages/userterms/userterms.module').then(m => m.UserTermsModule) },
      { path: 'forsida/um-okkur/personuverndarstefna', loadChildren: () => import('./components/pages/personuverndarstefna/personuverndarstefna.module').then(m => m.PersonuverndarstefnaModule) },
      { path: 'forsida/fyrirspurn-eftirlitsnefndar-fasteignasala/yfirlit', loadChildren: () => import('./components/pages/eftirlitsnefnd-fasteignasala/eftirlitsnefnd-fasteignasala.module').then(m => m.EftirlitsnefndFasteignasalaModule) },
      { path: 'forsida/um-okkur/verdskra', loadChildren: () => import('./components/pages/pricing/pricing.module').then(m => m.PricingModule) },
      { path: 'forsida/hafa-samband', loadChildren: () => import('./components/pages/contact/contact.module').then(m => m.ContactModule) },
      { path: 'forsida/god-rad', loadChildren: () => import('./components/pages/home/home.module').then(m => m.HomeModule) },
      { path: 'forsida/god-rad/oll', loadChildren: () => import('./components/pages/home/home.module').then(m => m.HomeModule) },
      { path: 'forsida/um-okkur/almennt', loadChildren: () => import('./components/pages/home/home.module').then(m => m.HomeModule) },
      {
        path: 'forsida/um-okkur/almennt',
        component: PageContainerComponent,
        canActivate: [],
        resolve: {
          redirect: () => {
            window.location.href = environment.rootPublicUrl + "/um-okkur";
            return false;
          }
        }
      },
      {
        path: 'forsida/login',
        component: PageContainerComponent,
        canActivate: [],
        resolve: {
          redirect: () => {
            window.location.href = environment.portalUrl;
            return false;
          }
        }
      },
      {
        path: 'forsida/tilbod/kaup-og-gangtilbod/kauptilbod/:fasteignId',
        component: PageContainerComponent,
        canActivate: [],
        resolve: {
          redirect: (route: ActivatedRouteSnapshot) => {
            const fasteignId = route.params['fasteignId'];
            window.location.href = `${environment.portalUrl}/nytt-kauptilbod/${fasteignId}`;
            return false;
          }
        }
      }
    ]
  },

  // MBL kaupsagan (forsíða - listi)
  {
    path: 'mbl',
    component: PageContainerSimpleComponent,
    children: [
      { path: 'kaupsagan', loadChildren: () => import('./components/pages/properties-sold/properties-sold.module').then(m => m.PropertiesSoldModule) }
    ]
  },
  {
    path: 'mbl-test',
    component: PageContainerSimpleComponent,
    children: [
      { path: 'kaupsagan', loadChildren: () => import('./components/pages/properties-sold/properties-sold.module').then(m => m.PropertiesSoldModule) }
    ]
  },
  { path: '**', component: NotFoundComponent }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules, // <- comment this line for activate lazy load
      initialNavigation: 'enabledBlocking', // for one load page, without reload
      // useHash: true
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
